module.exports = __webpack_public_path__ + "img/case06.fb4006fe.png";